const open_modal = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

open_modal(() => {
   const modalOpenButtons = document.querySelectorAll('.js-open-modal');
   const modalCloseButtons = document.querySelectorAll('.js-close-modal');
   const modalLayouts = document.querySelectorAll('.wcl-modal-layout');
   const body = document.querySelector('body');

   function openModal(modalId) {
      const modalLayout = document.getElementById(modalId);
      if (modalLayout) {
         modalLayout.classList.add('active');
         body.classList.add('overflow-hidden');
      }
   }

   function closeModal() {
      modalLayouts.forEach(function (modalLayout) {
         modalLayout.classList.remove('active');
         body.classList.remove('overflow-hidden');
      });
   }

   modalOpenButtons.forEach(function (button) {
      button.addEventListener('click', function () {
         const modalId = this.getAttribute('data-modal');
         openModal(modalId);
      });
   });

   modalCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
         closeModal();
      });
   });

   modalLayouts.forEach(function (modalLayout) {
      modalLayout.addEventListener('click', function (event) {
         if (!event.target.closest('.data-modal-wrapper')) {
            closeModal();
         }
      });
   });


   /*
   * Hide modal popup after form submission
   */
   document.addEventListener('wpcf7mailsent', function (event) {
      setTimeout(function () {
         closeModal();
      }, 4000);
   }, false);
});
